export default {
  get: function() {
    return {
      classes: [],
      fetching: false,
      error: false
    }
  }
}
